// One card per vocabulary entry. Surfaces the three translation layers
// (Norwegian / natural English / literal) and the SRS progress badge.

import { AudioButton } from './AudioButton.js';
import { getCard } from '../utils/srs.js';

function progressBadge(box, seen) {
  if (box >= 5) return `<span class="badge bg-moss-100 text-moss-800">✓ Mastered</span>`;
  if (seen > 0) return `<span class="badge bg-sand-200 text-slate2-700">Learning · box ${box}</span>`;
  return `<span class="badge bg-sand-100 text-slate2-500">New</span>`;
}

function verbTable(word) {
  if (word.type !== 'verb' || !word.present) return '';
  return `
    <div class="mt-4 grid grid-cols-3 gap-2 text-xs">
      ${[['Present', word.present], ['Past', word.past], ['Perfect', word.perfect]]
        .map(([label, value]) => `
          <div class="rounded-lg bg-sand-100 px-2.5 py-1.5">
            <div class="text-slate2-500 uppercase tracking-wide text-[10px]">${label}</div>
            <div class="font-medium text-slate2-700 mt-0.5">${value}</div>
          </div>
        `).join('')}
    </div>
  `;
}

function noteBlock(word) {
  if (!word.notes) return '';
  return `
    <div class="mt-3 text-xs text-slate2-500 italic
                border-l-2 border-moss-300 pl-3 leading-relaxed">
      ${word.notes}
    </div>
  `;
}

export function WordCard(word) {
  const progress = getCard(word.id);
  return `
    <article class="card animate-slide-up">
      <div class="flex items-start justify-between gap-3">
        <div class="min-w-0">
          <div class="mb-1.5">${progressBadge(progress.box, progress.seen)}</div>
          <h3 class="font-display text-2xl font-semibold text-slate2-900 leading-tight">
            ${word.no}
          </h3>
          <div class="text-slate2-500 text-sm mt-1">${word.en}</div>
        </div>
        ${AudioButton(word.no)}
      </div>
      <div class="mt-3 text-xs text-slate2-500">
        <span class="text-slate2-700/70 font-semibold uppercase tracking-wider text-[10px]">Literal</span>
        <span class="ml-1.5">${word.literal}</span>
      </div>
      ${verbTable(word)}
      ${noteBlock(word)}
    </article>
  `;
}
